import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "userinfo-form" }
const _hoisted_2 = {
  key: 0,
  class: "row q-gutter-sm q-mb-md"
}
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "q-mb-none q-ml-sm q-mt-sm" }
const _hoisted_5 = { class: "row q-gutter-sm" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  key: 1,
  class: "row q-gutter-sm"
}
const _hoisted_9 = { class: "col" }
const _hoisted_10 = {
  key: 2,
  class: "row q-gutter-sm"
}
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "row q-gutter-sm" }
const _hoisted_13 = { class: "col" }

import { computed } from 'vue';
import UserAttributeRadio from '../../radio/UserAttributeRadio.vue';
import DisplayModeCode from '../../../common/code/DisplayModeCode';
import { isEmpty, isHalfKana, isValidateEmail } from '../../../common/utils/validateUtils';

interface Props {
  // ユーザー情報
  memberInfo: {
    user_name_sei: string;
    user_name_mei: string;
    mail_address: string;
    mail_address_conf: string;
    user_attribute: string;
  };
  // メールアドレスエラーフラグ
  isMailAddressErr?: boolean;
  // 表示モード
  mode: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserInfoForm',
  props: {
    memberInfo: {},
    isMailAddressErr: { type: Boolean },
    mode: {}
  },
  emits: ['update:inputData', 'isMailAddressErr'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// 入力値
const inputData = computed({
  get: () => props.memberInfo,
  set: (value) => {
    emit('update:inputData', value);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode === _unref(DisplayModeCode).CHANGE)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[10] || (_cache[10] = _createElementVNode("label", null, "会員ID（メールアドレス）", -1)),
            _createElementVNode("p", _hoisted_4, _toDisplayString(inputData.value.mail_address), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[11] || (_cache[11] = _createElementVNode("label", {
          for: "name",
          class: "requier"
        }, "お名前（姓）", -1)),
        _createVNode(_component_q_input, {
          ref: "nameSeiElem",
          modelValue: inputData.value.user_name_sei,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputData.value.user_name_sei) = $event)),
          outlined: "",
          maxlength: "100",
          dense: "",
          rules: [
            (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
            (val) => !_unref(isHalfKana)(val) || _ctx.$t('validation.half_kana'),
          ],
          "lazy-rules": "",
          autofocus: "",
          class: "input-area",
          hint: "例）山田",
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
        }, null, 8, ["modelValue", "rules"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "requier" }, "お名前（名）", -1)),
        _createVNode(_component_q_input, {
          modelValue: inputData.value.user_name_mei,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputData.value.user_name_mei) = $event)),
          outlined: "",
          dense: "",
          maxlength: "100",
          rules: [
            (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
            (val) => !_unref(isHalfKana)(val) || _ctx.$t('validation.half_kana'),
          ],
          "lazy-rules": "",
          class: "input-area",
          hint: "例）太郎",
          onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
        }, null, 8, ["modelValue", "rules"])
      ])
    ]),
    (_ctx.mode === _unref(DisplayModeCode).REGISTER)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "requier" }, "会員ID（メールアドレス）", -1)),
            _createVNode(_component_q_input, {
              ref: "mailaddressElem",
              modelValue: inputData.value.mail_address,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => ((inputData.value.mail_address) = $event)),
                _cache[5] || (_cache[5] = ($event: any) => (emit('isMailAddressErr', false)))
              ],
              outlined: "",
              type: "email",
              dense: "",
              maxlength: "254",
              rules: [
            (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
            (val) => _unref(isValidateEmail)(val) || _ctx.$t('validation.email'),
          ],
              "lazy-rules": "",
              class: "input-area left-input",
              hint: "例）example@xxx.com",
              error: props.isMailAddressErr,
              onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
            }, null, 8, ["modelValue", "rules", "error"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.mode === _unref(DisplayModeCode).REGISTER)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "requier" }, "会員ID（メールアドレス）確認", -1)),
            _createVNode(_component_q_input, {
              modelValue: inputData.value.mail_address_conf,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((inputData.value.mail_address_conf) = $event)),
              outlined: "",
              dense: "",
              type: "email",
              maxlength: "254",
              rules: [
            (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
            (val) => _unref(isValidateEmail)(val) || _ctx.$t('validation.email'),
            (val) => val === inputData.value.mail_address || _ctx.$t('validation.same_email'),
          ],
              "reactive-rules": "",
              class: "input-area left-input",
              onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
            }, null, 8, ["modelValue", "rules"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "requier" }, "ご担当", -1)),
        _createVNode(UserAttributeRadio, {
          value: inputData.value.user_attribute,
          onSelectValue: _cache[9] || (_cache[9] = ($event: any) => (inputData.value.user_attribute = $event))
        }, null, 8, ["value"])
      ])
    ])
  ]))
}
}

})